import React from "react";
import { Grid, Typography } from "@mzc-pdc/ui";
import { ImageEmptySearchMini, ImageEmpty } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import { useTranslation } from "react-i18next";

export const NoSearchResultsIcon = ({ icon, title, subTitle, titleProps = {}, subTitleProps = {} }) => {
    const { t } = useTranslation();
    return (
        <Grid
            container
            justifyContent={"center"}
            alignItems={`center`}
            flexDirection={"column"}
            sx={{ height: "100%" }}
        >
            {icon ? icon : <ImageEmptySearchMini width={24} height={24} />}
            <Typography
                variant={titleProps.variant ?? undefined}
                component={"span"}
                color={theme.palette.greySecondary.main}
                sx={{ ...titleProps }}
            >
                {t(`common::msg::${title ? title : "No search results found."}`)}
            </Typography>
            {subTitle && (
                <Typography component={"span"} color={theme.palette.greySecondary[600]} sx={{ ...subTitleProps }}>
                    {t(`common::msg::${subTitle ? subTitle : "No search results found."}`)}
                </Typography>
            )}
        </Grid>
    );
};
